import { render, staticRenderFns } from "./DingtalkBind.vue?vue&type=template&id=0e7c7b4b&scoped=true"
import script from "./DingtalkBind.vue?vue&type=script&lang=js"
export * from "./DingtalkBind.vue?vue&type=script&lang=js"
import style0 from "./DingtalkBind.vue?vue&type=style&index=0&id=0e7c7b4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c7b4b",
  null
  
)

export default component.exports